import { useEffect } from 'react';
import { useTenant } from '../context/TenantContext';
import { resolveBrandingColors } from './brandingColors';
import { applyDocumentBranding } from './documentBranding';

const BRANDING_VARS = [
  '--tenant-brand',
  '--tenant-brand-hover',
  '--tenant-brand-contrast',
  '--tenant-brand-rgb',
  '--tenant-accent',
  '--tenant-navbar',
  '--primary-red',
  '--tenant-text-color',
];

/**
 * Applies tenant branding tokens to the document (CSS variables + title + favicon).
 * Presentation only — no data or routing impact.
 */
export function TenantBrandingEffect() {
  const { config } = useTenant();

  useEffect(() => {
    applyDocumentBranding(config);

    if (!config?.branding) {
      return undefined;
    }

    const {
      primaryColor,
      accentColor,
      primaryHoverColor,
      primaryContrastColor,
      primaryRgb,
    } = resolveBrandingColors(config.branding);
    const root = document.documentElement;

    root.style.setProperty('--tenant-brand', primaryColor);
    root.style.setProperty('--tenant-brand-hover', primaryHoverColor);
    root.style.setProperty('--tenant-brand-contrast', primaryContrastColor);
    root.style.setProperty('--tenant-brand-rgb', primaryRgb);
    root.style.setProperty('--tenant-accent', accentColor);
    root.style.setProperty('--tenant-navbar', primaryColor);
    root.style.setProperty('--primary-red', primaryColor);
    root.style.setProperty('--tenant-text-color', primaryColor);

    return () => {
      BRANDING_VARS.forEach((name) => root.style.removeProperty(name));
    };
  }, [
    config,
    config?.branding?.primaryColor,
    config?.branding?.accentColor,
    config?.branding?.primaryHoverColor,
    config?.branding?.logoPath,
    config?.branding?.appTitle,
    config?.displayName,
    config?.footer?.copyright,
  ]);

  return null;
}
